// utils related to live tracking

import {
  LiveEntityType,
  OrderTripLiveStatus
} from '../components/TwLiveTrackingAlert/TwLiveTrackingAlert';
import { ORDER_STATUS, Order } from '../redux/api/orders/orders.model';
import { Trip, TRIP_STATUS } from '../redux/api/trips/trips.model';

export const getLiveTrackEntity = (currentTab: number): LiveEntityType => {
  if (currentTab === 0) {
    return LiveEntityType.order;
  }
  return LiveEntityType.trip;
};

export const getLiveStatus = (
  order: Order | undefined,
  currentTab: number,
  trips: Trip[] | undefined
): OrderTripLiveStatus => {
  const entityToTrack = getLiveTrackEntity(currentTab);
  // if simple load or full route tab return as per load status
  if (entityToTrack === LiveEntityType.order) {
    switch (order?.status) {
      case ORDER_STATUS.NOT_STARTED:
        return OrderTripLiveStatus.notStarted;

      case ORDER_STATUS.IN_TRANSIT:
        return OrderTripLiveStatus.inTransit;

      default:
        return OrderTripLiveStatus.delivered;
    }
  } else {
    // for segment tab return as per segment status
    const segment = trips?.[currentTab - 1];
    switch (segment?.status) {
      case TRIP_STATUS.DRAFT:
        return OrderTripLiveStatus.notStarted;

      case TRIP_STATUS.IN_TRANSIT:
        return OrderTripLiveStatus.inTransit;

      default:
        return OrderTripLiveStatus.delivered;
    }
  }
};
